export interface ThreeDotsLoaderProps {
    'data-testid'?: string
}

const ThreeDotsLoader = ({ 'data-testid': dataTestId }: ThreeDotsLoaderProps) => {
    return (
        <div
            data-testid={dataTestId ?? '__three-dots-loader__'}
            className="flex items-center justify-center gap-1 min-h-4"
        >
            <span className="h-[9px] w-[9px] rounded-full bg-iconSecondary animate-bounce [animation-delay:-0.3s]" />
            <span className="h-[9px] w-[9px] rounded-full bg-iconSecondary animate-bounce [animation-delay:-0.15s]" />
            <span className="h-[9px] w-[9px] rounded-full bg-iconSecondary animate-bounce" />
        </div>
    )
}

export default ThreeDotsLoader
